export default __webpack_public_path__ + "static/event-list-item-bb96a014ed6185816698c6b6b40f6117.png";